"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppContext = exports.DefaultTaskDispatcher = exports.TASK_MESSAGE_TYPE = void 0;
const react_1 = __importDefault(require("react"));
const rxjs_1 = require("rxjs");
var TASK_MESSAGE_TYPE;
(function (TASK_MESSAGE_TYPE) {
    TASK_MESSAGE_TYPE["willExecute"] = "willExecute";
    TASK_MESSAGE_TYPE["didExecute"] = "didExecute";
    TASK_MESSAGE_TYPE["didFail"] = "didFail";
    TASK_MESSAGE_TYPE["willTerminate"] = "willTerminate";
    TASK_MESSAGE_TYPE["didTerminate"] = "didTerminate";
})(TASK_MESSAGE_TYPE = exports.TASK_MESSAGE_TYPE || (exports.TASK_MESSAGE_TYPE = {}));
class DefaultTaskDispatcher {
    constructor() {
        this.subject = new rxjs_1.Subject();
        this.willExecute = (input) => {
            this.subject.next({ type: TASK_MESSAGE_TYPE.willExecute, payload: input });
        };
        this.didExecute = (input) => {
            this.subject.next({ type: TASK_MESSAGE_TYPE.didExecute, payload: input });
        };
        this.didFail = (input) => {
            this.subject.next({ type: TASK_MESSAGE_TYPE.didFail, payload: input });
        };
        this.willTerminate = (input) => {
            this.subject.next({ type: TASK_MESSAGE_TYPE.willTerminate, payload: input });
        };
        this.didTerminate = (input) => {
            this.subject.next({ type: TASK_MESSAGE_TYPE.didTerminate, payload: input });
        };
    }
    asObservable() {
        return this.subject.asObservable();
    }
}
exports.DefaultTaskDispatcher = DefaultTaskDispatcher;
const appContextNoop = () => {
    throw new Error('AppContext error: you must provide AppContext');
};
if (!window.internalAppContext) {
    window.internalAppContext = react_1.default.createContext({
        getToken: appContextNoop,
        getApiRequest: appContextNoop,
        getLogger: appContextNoop,
        getErrorListener: appContextNoop,
        getErrorStream: appContextNoop,
        taskDispatcher: new DefaultTaskDispatcher()
    });
}
exports.AppContext = window.internalAppContext;
//# sourceMappingURL=AppContext.js.map